var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_37_175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 31,
    r: 16,
    fill: "#005EA3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1616 33.5396C44.1441 33.5163 44.1253 33.4945 44.1051 33.4736C43.5237 32.7466 42.4727 32.6006 41.7398 33.1507C40.6836 33.9292 38.8765 35.2392 38.2734 35.6764L35.6387 35.4698L37.2507 35.117C38.1142 34.9913 38.7332 34.2294 38.6958 33.3301C38.6956 33.3206 38.6949 33.3111 38.694 33.3018C38.6192 32.4031 37.889 31.7256 36.9958 31.7256H32.1205C31.7244 31.7256 31.3548 31.827 31.0219 32.0267C31.0086 32.0349 30.9954 32.0433 30.9825 32.0523L25.7897 35.6805C25.4818 35.8957 25.4065 36.3199 25.6217 36.6276C25.8366 36.9358 26.2611 37.0113 26.5688 36.7956L31.7398 33.1827C31.855 33.1176 31.9797 33.0856 32.1207 33.0856H36.996C37.177 33.0856 37.3153 33.2144 37.3371 33.4004C37.3387 33.5641 37.2505 33.7459 37.0477 33.7713C37.0273 33.7738 37.0069 33.7772 36.9867 33.7818L34.0842 34.4167C33.8577 34.4663 33.672 34.6278 33.5915 34.8452C33.511 35.0629 33.5468 35.3064 33.6867 35.4915L34.4577 36.5119C34.5749 36.6672 34.7532 36.7649 34.9473 36.7801L38.4166 37.0522C38.5772 37.0638 38.738 37.0196 38.8686 36.925C38.8923 36.9078 41.2668 35.1892 42.5513 34.2425C42.698 34.1325 42.9314 34.1742 43.05 34.3329C43.0631 34.3504 43.0772 34.3674 43.0919 34.3833C43.1833 34.5327 43.1484 34.7243 43.0035 34.8329L38.402 38.3013C38.2666 38.4027 38.1255 38.4412 37.9643 38.4199L31.2523 37.5809C31.0691 37.558 30.8849 37.6104 30.7412 37.726L28.1788 39.7897C27.8861 40.0256 27.84 40.4539 28.0757 40.7464C28.2099 40.9133 28.407 40.9999 28.6058 40.9999C28.7557 40.9999 28.9065 40.9507 29.0319 40.8498L31.3696 38.967L37.7898 39.7695C38.3018 39.8378 38.7952 39.7065 39.219 39.389L43.8213 35.9208C44.5716 35.358 44.7242 34.29 44.1616 33.5396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 23.3584C37.7307 23.3584 37.4262 23.6629 37.4262 24.0387V28.1203C37.4262 28.4961 37.7307 28.8006 38.1065 28.8006C38.4822 28.8006 38.7868 28.4961 38.7868 28.1203V24.0387C38.7868 23.6629 38.4822 23.3584 38.1065 23.3584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1473 25.3989H36.0657C35.6899 25.3989 35.3854 25.7035 35.3854 26.0792C35.3854 26.4549 35.6899 26.7595 36.0657 26.7595H40.1473C40.5231 26.7595 40.8276 26.4549 40.8276 26.0792C40.8276 25.7035 40.5231 25.3989 40.1473 25.3989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 21C35.3056 21 33.0273 23.2785 33.0273 26.0794C33.0273 28.8803 35.3056 31.1587 38.1065 31.1587C40.9071 31.1587 43.1859 28.8803 43.1859 26.0794C43.1859 23.2784 40.9074 21 38.1065 21ZM38.1065 29.7982C36.0559 29.7982 34.3879 28.13 34.3879 26.0794C34.3879 24.0288 36.0559 22.3605 38.1065 22.3605C40.157 22.3605 41.8253 24.0288 41.8253 26.0794C41.8253 28.13 40.1571 29.7982 38.1065 29.7982Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_37_175",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.470588 0 0 0 0 0.94902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_175",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_37_175"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(25 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareness);
export default __webpack_public_path__ + "static/media/careness.d546d87cfce2ee50b39dde485bac91fa.svg";
export { ForwardRef as ReactComponent };